import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const MilesSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M5.88258 15.0478C6.39499 15.0478 6.81815 14.6159 6.81815 14.1083C6.81815 13.5871 6.39499 13.1727 5.88258 13.1727C5.36623 13.1727 4.94307 13.5871 4.94307 14.1083C4.94307 14.6159 5.36623 15.0478 5.88258 15.0478ZM4.14749 10.9478C4.66381 10.9478 5.08698 10.5246 5.08698 10.0083C5.08698 9.49195 4.66381 9.06876 4.14749 9.06876C3.63115 9.06876 3.20799 9.49195 3.20799 10.0083C3.20799 10.5246 3.63115 10.9478 4.14749 10.9478ZM5.86515 6.84386C6.37756 6.84386 6.80075 6.42069 6.80075 5.90826C6.80075 5.39194 6.37756 4.96875 5.86515 4.96875C5.34881 4.96875 4.92564 5.39194 4.92564 5.90826C4.92564 6.42069 5.34881 6.84386 5.86515 6.84386ZM9.9913 5.06912C10.5076 5.06912 10.9308 4.64595 10.9308 4.12961C10.9308 3.61329 10.5076 3.19403 9.9913 3.19403C9.47495 3.19403 9.05179 3.61329 9.05179 4.12961C9.05179 4.64595 9.47495 5.06912 9.9913 5.06912ZM15.8438 10.9478C16.3602 10.9478 16.7833 10.5246 16.7833 10.0083C16.7833 9.49195 16.3602 9.06876 15.8438 9.06876C15.3275 9.06876 14.9043 9.49195 14.9043 10.0083C14.9043 10.5246 15.3275 10.9478 15.8438 10.9478ZM14.1087 15.0478C14.6164 15.0478 15.0482 14.6159 15.0482 14.1083C15.0482 13.5871 14.6164 13.1727 14.1087 13.1727C13.5963 13.1727 13.1731 13.5871 13.1731 14.1083C13.1731 14.6159 13.5963 15.0478 14.1087 15.0478ZM8.49796 11.4312C9.26553 12.1735 10.3017 12.0007 10.9365 11.109L14.9416 5.66411C15.2811 5.20434 14.7952 4.72623 14.3394 5.04931L8.7988 8.96741C7.90803 9.60302 7.74 10.6549 8.49796 11.4312ZM10 20.0044C15.4734 20.0044 20.0087 15.4778 20.0087 10.0044C20.0087 4.53095 15.4647 0.00436401 9.9913 0.00436401C4.52267 0.00436401 0 4.53095 0 10.0044C0 15.4778 4.53138 20.0044 10 20.0044ZM10 18.5316C5.28039 18.5316 1.48627 14.7327 1.48627 10.0044C1.48627 5.27603 5.27168 1.47713 9.9913 1.47713C14.7196 1.47713 18.5272 5.27603 18.5272 10.0044C18.5272 14.7327 14.7283 18.5316 10 18.5316Z"
        fill={color}
      />
    </svg>
  );
};

export { MilesSvg };
